import Collection from '../../utils/Collection';

import {
  FETCH_LESSON_SENT,
  FETCH_LESSON_FAILED,
  FETCH_MY_LESSONS_SENT,
  FETCH_MY_LESSONS_SUCCEEDED,
  FETCH_MY_LESSONS_FAILED,
  MARK_LESSON_AS_SKIPPED_BY_TUTOR_SENT,
  MARK_LESSON_AS_SKIPPED_BY_TUTOR_SUCCEEDED,
  MARK_LESSON_AS_SKIPPED_BY_TUTOR_FAILED,
  GET_MY_LESSON_SIZE_SENT,
  GET_MY_LESSON_SIZE_FAILED,
  GET_MY_LESSON_SIZE_SUCCEEDED,
} from '../../actions/lesson';

import {
  CREATE_LESSON_REVIEW_SENT,
  CREATE_LESSON_REVIEW_SUCCEEDED,
  CREATE_LESSON_REVIEW_FAILED,
} from '../../actions/lessonReview';

import {
  REPORT_LESSON_ISSUE_SENT,
  REPORT_LESSON_ISSUE_SUCCEEDED,
  REPORT_LESSON_ISSUE_FAILED,
  RESOLVE_LESSON_ISSUE_SENT,
  RESOLVE_LESSON_ISSUE_SUCCEEDED,
  RESOLVE_LESSON_ISSUE_FAILED,
  REPORT_AND_RESOLVE_LESSON_ISSUE_SENT,
  REPORT_AND_RESOLVE_LESSON_ISSUE_SUCCEEDED,
  REPORT_AND_RESOLVE_LESSON_ISSUE_FAILED,
} from '../../actions/lessonIssue';

const initialState = {
  myLessons: [],
  myLessonsUpdatedAt: null,
  myLessonSize: {
    lastMonth: 0,
    thisMonth: 0,
    total: 0,
  },
  numOfLessons: 0,
  leaveSummaryWarning: false,
  loading: false,
  loadedOnce: false,
  loadingSize: false,
  loadedSizeOnce: false,
  saving: false,
  savingReview: false,
  page: 1,
};

export default function lessonReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_MY_LESSONS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        loadedOnce: true,
        myLessons: Collection.reset(state.myLessons, payload.lessons),
        numOfLessons: payload.numOfLessons,
      };
    case FETCH_LESSON_SENT:
    case FETCH_MY_LESSONS_SENT:
      return {
        ...state,
        loading: true,
        page: payload.page,
      };
    case FETCH_LESSON_FAILED:
    case FETCH_MY_LESSONS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case MARK_LESSON_AS_SKIPPED_BY_TUTOR_SENT:
      return {
        ...state,
        saving: true,
      };
    case MARK_LESSON_AS_SKIPPED_BY_TUTOR_SUCCEEDED:
      return {
        ...state,
        saving: false,
        myLessons: Collection.removeAndAdd(
          state.myLessons,
          payload.updated_lesson,
        ),
        myLessonsUpdatedAt: new Date(),
      };
    case REPORT_LESSON_ISSUE_SUCCEEDED:
    case RESOLVE_LESSON_ISSUE_SUCCEEDED:
    case REPORT_AND_RESOLVE_LESSON_ISSUE_SUCCEEDED:
      const newLessons = Collection.removeAndAdd(
        state.myLessons,
        payload.lesson,
      );
      return {
        ...state,
        saving: false,
        myLessons: newLessons,
        myLessonsUpdatedAt: new Date(),
      };
    case REPORT_LESSON_ISSUE_SENT:
    case RESOLVE_LESSON_ISSUE_SENT:
    case REPORT_AND_RESOLVE_LESSON_ISSUE_SENT:
      return {
        ...state,
        saving: true,
      };
    case REPORT_LESSON_ISSUE_FAILED:
    case RESOLVE_LESSON_ISSUE_FAILED:
    case REPORT_AND_RESOLVE_LESSON_ISSUE_FAILED:
      return {
        ...state,
        saving: false,
      };
    case MARK_LESSON_AS_SKIPPED_BY_TUTOR_FAILED:
    case CREATE_LESSON_REVIEW_FAILED:
      return {
        ...state,
        saving: false,
      };
    case CREATE_LESSON_REVIEW_SENT:
      return {
        ...state,
        savingReview: true,
      };
    case CREATE_LESSON_REVIEW_SUCCEEDED:
      return {
        ...state,
        savingReview: false,
        myLessons: Collection.removeAndAdd(
          state.myLessons,
          payload.updated_lesson,
        ),
        myLessonsUpdatedAt: new Date(),
      };
    case GET_MY_LESSON_SIZE_SENT:
      return {
        ...state,
        loadingSize: true,
      };
    case GET_MY_LESSON_SIZE_FAILED:
      return {
        ...state,
        loadingSize: false,
      };
    case GET_MY_LESSON_SIZE_SUCCEEDED:
      return {
        ...state,
        loadingSize: false,
        loadedSizeOnce: true,
        myLessonSize: {
          lastMonth: payload.last_month_size,
          thisMonth: payload.this_month_size,
          total: payload.total_size,
        },
      };
    default:
      return state;
  }
}
